import React from 'react'
import { string, func } from 'prop-types'

import { MenuItem } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Letter from './KeywordLetter'

function Keyword({
  searchKeyword,
  suggestedKeyword,
  thumbnailUrl = '',
  onKeywordClick,
}) {
  const lowerCasedQuery = searchKeyword.toLowerCase()
  const label = (
    <div className="cgt-model-search__suggestion-wrapper">
      {thumbnailUrl && (
        <img
          src={thumbnailUrl}
          alt=""
          className="cgt-model-search__suggestion-thumbnail"
        />
      )}
      <span>
        {[...suggestedKeyword].map((letter, index) => (
          <Letter
            key={`${suggestedKeyword}-letter-${index}`}
            char={letter}
            isBolded={lowerCasedQuery.includes(letter)}
          />
        ))}
      </span>
    </div>
  )

  const onClick = () => onKeywordClick({ suggestedKeyword })

  return (
    <li className="cgt-model-search__suggestion">
      <MenuItem fluid label={label} onClick={onClick} />
    </li>
  )
}

Keyword.propTypes = {
  suggestedKeyword: string.isRequired,
  searchKeyword: string.isRequired,
  onKeywordClick: func.isRequired,
  thumbnailUrl: string,
}

export default Keyword
